import { Divider, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

interface ProfileCardFooterProps {
  children?: React.ReactNode;
  className?: string;
  dataTestId?: string;
}

export default function ProfileCardFooter({ children, className = '', dataTestId }: ProfileCardFooterProps) {
  const classes = useStyles();
  return (
    <>
      <Divider />
      <div className={`${classes.root} ${className}`} data-testid={dataTestId}>
        {children}
      </div>
    </>
  );
}

const useStyles = makeStyles((_theme: Theme) => ({
  root: {
    padding: '12px 24px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
}));
